import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs-compat';
import { ConfigServices } from 'src/app/core/config';
import { ServicesService } from 'src/app/users/services.service';

@Injectable({
  providedIn: 'root'
})
export class SharedServiceService extends ServicesService {

  private dataSource = new BehaviorSubject<any>(null);
  data$ = this.dataSource.asObservable();

  constructor(public http: HttpClient, public configService: ConfigServices) { 
    super('shared-service', http, configService);
  }

  sendData(data: any) {
    this.dataSource.next(data);
  }

  acceptOffer( applicationId: string, offerType: string) {
    if (offerType === 'BURSARY') {
      return this.http.post(this.configService.getApi() + 'loans/applications/apply/' + applicationId, { withCredentials: true });
    }

    if (offerType === 'LOAN') {
      return this.http.post(this.configService.getApi() + 'applications/accept-bursary-offer/' + applicationId, { withCredentials: true });
    }

    throw new Error('Invalid offer type');
  }
}